export const AFYA_IMARA_QUOTE_FORM = 'afyaImara/quoteForm/';

export const AFYA_IMARA_QUOTE_FORM_SET_VALUE = AFYA_IMARA_QUOTE_FORM + 'setValue/';
export const AFYA_IMARA_QUOTE_FORM_SET_VALID = AFYA_IMARA_QUOTE_FORM + 'setValid/';
export const FORM_VALID_AFYA_IMARA_QUOTE_FORM = 'afyaImara/quoteForm/transition/formValid';
export const FORM_INVALID_AFYA_IMARA_QUOTE_FORM = 'afyaImara/quoteForm/transition/formInValid';

export const AFYA_IMARA_QUOTE_ADD_COVER = AFYA_IMARA_QUOTE_FORM + 'addCover/';

export const AFYA_IMARA_QUOTE_SHOW_COVER_OPTIONS = AFYA_IMARA_QUOTE_FORM + 'coverOptions/';

export const FORM_VALID_AFYA_IMARA_QUOTE_SHARE_FORM = 'afyaImara/shareQuoteForm/transition/formValid';
export const FORM_INVALID_AFYA_IMARA_QUOTE_SHARE_FORM = 'afyaImara/shareQuoteForm/transition/formInValid';
export const AFYA_IMARA_SHARE_QUOTE_VALUE = AFYA_IMARA_QUOTE_FORM + 'shareQuote';

export const TOKEN_IS_EXPIRED = 'afyaImara/expiredAuth';

export const AFYA_IMARA_SIDEBAR_OPEN_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'sidebarOpen';

export const REINITIALIZE = AFYA_IMARA_QUOTE_FORM + '/state/reinitialize';

// VALIDATE QUOTE FORM
export const transitionafyaImaraQuoteForm = {
    formValid: () => ({
        type: FORM_VALID_AFYA_IMARA_QUOTE_FORM,
    }),
    formInvalid: () => ({
        type: FORM_INVALID_AFYA_IMARA_QUOTE_FORM,
    }),
};

export const transitionShareQuoteForm = {
    formInvalid: () => ({
        type: FORM_VALID_AFYA_IMARA_QUOTE_SHARE_FORM,
    }),
    formValid: () => ({
        type: FORM_INVALID_AFYA_IMARA_QUOTE_SHARE_FORM,
    }),
};

//cover options
export const SET_COVER_OPTIONS_LIST_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'coverOptionsList';
export const SET_COVER_OPTIONS_LIST_VALID = AFYA_IMARA_QUOTE_FORM_SET_VALID + 'coverOptionsList';

export const SET_SELECTED_PLAN_INDEX = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'comparison/selectedPlanIndex';

// API Calls actions
export const API_PENDING_TRANSITION_AFYA_IMARA_QUOTE_FORM = `${AFYA_IMARA_QUOTE_FORM_SET_VALUE}/apiTransition/pending`;
export const API_SUCCESS_TRANSITION_AFYA_IMARA_QUOTE_FORM = `${AFYA_IMARA_QUOTE_FORM_SET_VALUE}/apiTransition/success`;

export const API_PENDING_TRANSITIONS_PRODUCTS = `${SET_COVER_OPTIONS_LIST_VALUE}/apiTransition/pending`;
export const API_SUCCESS_TRANSITIONS_PRODUCTS = `${SET_COVER_OPTIONS_LIST_VALUE}/apiTransition/success`;
export const API_FAILURE_TRANSITIONS_PRODUCTS = `${SET_COVER_OPTIONS_LIST_VALUE}/apiTransition/failure`;

export const API_FAILURE_TRANSITION_AFYA_IMARA_QUOTE_FORM = `${AFYA_IMARA_QUOTE_FORM_SET_VALUE}/apiTransition/failure`;
export const API_PENDING_TRANSITIONS_SHARE_QUOTE_FORM = `${AFYA_IMARA_SHARE_QUOTE_VALUE}/apiTransition/pending`;
export const API_SUCCESS_TRANSITIONS_SHARE_QUOTE_FORM = `${AFYA_IMARA_SHARE_QUOTE_VALUE}/apiTransition/success`;
export const API_FAILURE_TRANSITIONS_SHARE_QUOTE_FORM = `${AFYA_IMARA_SHARE_QUOTE_VALUE}/apiTransition/failure`;

export const API_PENDING_TRANSITION_QUOTE_PAYLOAD_COLLECTION_FORM = `${AFYA_IMARA_QUOTE_FORM_SET_VALUE}/apiTransition/quotePayloadCollection/pending`;
export const API_SUCCESS_TRANSITION_QUOTE_PAYLOAD_COLLECTION_FORM = `${AFYA_IMARA_QUOTE_FORM_SET_VALUE}/apiTransition/quotePayloadCollection/success`;
export const API_FAILURE_TRANSITION_QUOTE_PAYLOAD_COLLECTION_FORM = `${AFYA_IMARA_QUOTE_FORM_SET_VALUE}/apiTransition/quotePayloadCollection/failure`;
export const API_INITIAL_TRANSITION_QUOTE_PAYLOAD_COLLECTION_FORM = `${AFYA_IMARA_QUOTE_FORM_SET_VALUE}/apiTransition/quotePayloadCollection/initial`;
// Comparison Transitions

export const PAGE_NAME_SET_VALUE = `${AFYA_IMARA_QUOTE_FORM_SET_VALUE}/pageName`;

export const API_PENDING_TRANSITION_AFYA_IMARA_COMPARISON = `${AFYA_IMARA_QUOTE_FORM_SET_VALUE}/apiTransition/comparison/pending`;
export const API_SUCCESS_TRANSITION_AFYA_IMARA_COMPARISON = `${AFYA_IMARA_QUOTE_FORM_SET_VALUE}/apiTransition/comparison/success`;
export const API_FAILURE_TRANSITION_AFYA_IMARA_COMPARISON = `${AFYA_IMARA_QUOTE_FORM_SET_VALUE}/apiTransition/comparison/failure`;

export const apiTransitionAfyaImaraInsuranceQuoteForm = {
    pending: () => ({
        type: API_PENDING_TRANSITION_AFYA_IMARA_QUOTE_FORM,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_AFYA_IMARA_QUOTE_FORM,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_AFYA_IMARA_QUOTE_FORM,
    }),
};

export const apiTransitionAfyaImaraInsuranceQuotePayloadCollectionForm = {
    pending: () => ({
        type: API_PENDING_TRANSITION_QUOTE_PAYLOAD_COLLECTION_FORM,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_QUOTE_PAYLOAD_COLLECTION_FORM,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_QUOTE_PAYLOAD_COLLECTION_FORM,
    }),
    initial: () => ({
        type: API_INITIAL_TRANSITION_QUOTE_PAYLOAD_COLLECTION_FORM,
    }),
};

// Comparison Transitions
export const apiTransitionAfyaImaraInsuranceComparison = {
    pending: () => ({
        type: API_PENDING_TRANSITION_AFYA_IMARA_COMPARISON,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_AFYA_IMARA_COMPARISON,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_AFYA_IMARA_COMPARISON,
    }),
};

// afya imara products api transition
export const apiTransitionAfyaImaraProducts = {
    pending: () => ({
        type: API_PENDING_TRANSITIONS_PRODUCTS,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITIONS_PRODUCTS,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITIONS_PRODUCTS,
    }),
};

export const apiTransitionShareQuoteForm = {
    pending: () => ({
        type: API_PENDING_TRANSITIONS_SHARE_QUOTE_FORM,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITIONS_SHARE_QUOTE_FORM,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITIONS_SHARE_QUOTE_FORM,
    }),
};

//triggers
export const TRIGGER_GET_ALL_PRODUCTS = AFYA_IMARA_QUOTE_FORM + 'triggerGetAllProducts';

//calculated Data
export const COLLECT_AFYA_IMARA_QUOTE_FORM_DATA = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'collectafyaImaraQuoteData';
export const SUBMIT_AFYA_IMARA_QUOTE_SUCCESS = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'success';
export const SUBMIT_AFYA_IMARA_QUOTE_FAILURE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'failure';
export const CALCULATE_AFYA_IMARA_PREMIUM_SUCCESS = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'calculatePremiumSuccess';
export const CALCULATE_AFYA_IMARA_PREMIUM_FAILURE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'failure';

export const COLLECT_SHARE_QUOTE_FORM_DATA = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'collectShareQuoteFormData';
export const SHARE_AFYA_IMARA_QUOTE_SUCCESS = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'shareQuoteSuccess';
export const SHARE_AFYA_IMARA_QUOTE_FAILURE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'shareQuoteFailure';
export const SET_SELECTED_PRODUCT_ID = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'selected/product/id';
export const COLLECT_PREMIUM_COMPARISON_DATA = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'collectComparisonData/';
export const COMPARISONS_DATA_FETCH_SUCCESS = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'comparisonData/fetch/success';

// OM Rescue Plus
export const SET_AFYA_IMARA_OM_RESCUE_PLUS_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'omRescuePlusValue';
export const SET_AFYA_IMARA_OM_RESCUE_PLUS_VALID = AFYA_IMARA_QUOTE_FORM_SET_VALID + 'omRescuePlusValid';

export const setOmRescuePlusValue = (value) => ({
    type: SET_AFYA_IMARA_OM_RESCUE_PLUS_VALUE,
    value,
});

export const setOmRescuePlusValid = (error) => ({
    type: SET_AFYA_IMARA_OM_RESCUE_PLUS_VALID,
    error,
});

export const setPageName = (value) => ({
    type: PAGE_NAME_SET_VALUE,
    value,
});

export const collectafyaImaraQuoteData = () => ({
    type: COLLECT_AFYA_IMARA_QUOTE_FORM_DATA,
});

export const submitafyaImaraQuoteSuccess = () => ({
    type: SUBMIT_AFYA_IMARA_QUOTE_SUCCESS,
    value,
});

export const submitafyaImaraQuoteFailure = () => ({
    type: SUBMIT_AFYA_IMARA_QUOTE_FAILURE,
    error,
});

export const collectShareQuoteFormData = () => ({
    type: COLLECT_SHARE_QUOTE_FORM_DATA,
});

export const collectComparisonData = () => ({
    type: COLLECT_PREMIUM_COMPARISON_DATA,
});

export const shareQuoteSuccess = (value) => ({
    type: SHARE_AFYA_IMARA_QUOTE_SUCCESS,
    value,
});

export const shareQuoteFailure = (error) => ({
    type: SHARE_AFYA_IMARA_QUOTE_FAILURE,
    error,
});

export const calculateAfyaImaraInsurancePremiumSuccess = (value) => ({
    type: CALCULATE_AFYA_IMARA_PREMIUM_SUCCESS,
    value,
});

export const fetchComparisonDataSuccess = (value) => ({
    type: COMPARISONS_DATA_FETCH_SUCCESS,
    value,
});

export const calculateAfyaImaraInsurancePremiumFailure = (error) => ({
    type: CALCULATE_AFYA_IMARA_PREMIUM_FAILURE,
    error,
});

export const addCover = (value) => ({
    type: AFYA_IMARA_QUOTE_ADD_COVER,
    value,
});

export const setSelectedProductId = (value) => ({
    type: SET_SELECTED_PRODUCT_ID,
    value,
});

export const setShowCoverOptions = (value) => ({
    type: AFYA_IMARA_QUOTE_SHOW_COVER_OPTIONS,
    value,
});

export const selectedPlanIndexComparison = (value) => ({
    type: SET_SELECTED_PLAN_INDEX,
    value,
});

// Form values
export const SET_UNCOMMON_RISK_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'uncommonRiskValue';
export const SET_UNCOMMON_RISK_VALID = AFYA_IMARA_QUOTE_FORM_SET_VALID + 'uncommonRiskValid';
export const SET_EXCESS_PROTECTOR_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'excessProtectorValue';
export const SET_EXCESS_PROTECTOR_VALID = AFYA_IMARA_QUOTE_FORM_SET_VALID + 'excessProtectorValid';
export const SET_SHARE_EMAIL_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'shareEmailValue';
export const SET_SHARE_EMAIL_VALID = AFYA_IMARA_QUOTE_FORM_SET_VALID + 'shareEmailValid';
export const SET_VIOLENCE_TERORISM_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'violenceAndTerrorismValue';
export const SET_VIOLENCE_TERORISM_VALID = AFYA_IMARA_QUOTE_FORM_SET_VALID + 'violenceAndTerrorismValid';

export const SET_INPATIENT_COVER_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'inpatientCoverValue';
export const SET_INPATIENT_COVER_VALID = AFYA_IMARA_QUOTE_FORM_SET_VALID + 'unpatientCoverValid';
export const SET_OUTPATIENT_COVER_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'outpatientCoverValue';
export const SET_OUTPATIENT_LIMIT_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'outpatientLimitValue';
export const SET_OUTPATIENT_COVER_VALID = AFYA_IMARA_QUOTE_FORM_SET_VALID + 'outpatientCoverValid';
export const SET_OUTPATIENT_COVER_OPTION_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'outpatientCoverOptionValue';
export const SET_OUTPATIENT_COVER_OPTION_VALID = AFYA_IMARA_QUOTE_FORM_SET_VALID + 'outpatientCoverOptionValid';

//quote details
export const DOB_SET_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'DOB';
export const DOB_SET_VALID = AFYA_IMARA_QUOTE_FORM_SET_VALID + 'DOB';
export const COVER_LIMIT_SET_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'coverLimit';
export const COVER_LIMIT_SET_VALID = AFYA_IMARA_QUOTE_FORM_SET_VALID + 'coverLimit';
export const PROFESSION_SET_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'profession';
export const PROFESSION_SET_VALID = AFYA_IMARA_QUOTE_FORM_SET_VALID + 'profession';
export const SPOUSE_INCLUDED_SET_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'spouseIncluded';
export const SPOUSE_INCLUDED_SET_VALID = AFYA_IMARA_QUOTE_FORM_SET_VALID + 'spouseIncluded';
export const SPOUSE_DOB_SET_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'spouseDob';
export const SPOUSE_DOB_SET_VALID = AFYA_IMARA_QUOTE_FORM_SET_VALID + 'spouseDob';
export const CHILDREN_INCLUDED_SET_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'childrenIncluded';
export const CHILDREN_INCLUDED_SET_VALID = AFYA_IMARA_QUOTE_FORM_SET_VALID + 'childrenIncluded';
export const CHILDREN_DOBS_SET_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'childrenDobs';
export const CHILDREN_DOBS_SET_VALID = AFYA_IMARA_QUOTE_FORM_SET_VALID + 'childrenDobs';
export const CHILDREN_DOBS_ARRAY_SET_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'childrenDobsArray';
export const CHILDREN_DOBS_ARRAY_SET_VALID = AFYA_IMARA_QUOTE_FORM_SET_VALID + 'childrenDobsArray';
export const SELECTED_COVER_OPTION_SET_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'selectedCoverOption';
export const SET_AFYA_IMARA_PRODUCTS_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'products';
export const SET_AFYA_IMARA_PRODUCTS_VALID = AFYA_IMARA_QUOTE_FORM_SET_VALID + 'products';
export const SET_SELECTED_AFYA_IMARA_PLAN = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'selectedPlanIndex';
export const SET_FULL_NAME_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'fullName';
export const SET_FULL_NAME_VALID = AFYA_IMARA_QUOTE_FORM_SET_VALID + 'fullName';
export const SET_EMAIL_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'email';
export const SET_EMAIL_VALID = AFYA_IMARA_QUOTE_FORM_SET_VALID + 'email';
export const SET_PHONE_NO_VALUE = AFYA_IMARA_QUOTE_FORM_SET_VALUE + 'phoneNumber';
export const SET_PHONE_NO_VALID = AFYA_IMARA_QUOTE_FORM_SET_VALID + 'phoneNumber';
// action creators

export const initializeQuoteForm = () => ({
    type: REINITIALIZE,
});

export const setSelectedPlanValue = (value) => ({
    type: SET_SELECTED_AFYA_IMARA_PLAN,
    value,
});

export const setUncommonRiskValue = (value) => ({
    type: SET_UNCOMMON_RISK_VALUE,
    value,
});

export const setUncommonRiskValid = (error) => ({
    type: SET_UNCOMMON_RISK_VALID,
    error,
});

export const setExcessProtectorValue = (value) => ({
    type: SET_EXCESS_PROTECTOR_VALUE,
    value,
});

export const setExcessProtectorValid = (error) => ({
    type: SET_EXCESS_PROTECTOR_VALID,
    error,
});

export const setViolenceAndTerrorismValue = (value) => ({
    type: SET_VIOLENCE_TERORISM_VALUE,
    value,
});

export const setViolenceAndTerrorismValid = (error) => ({
    type: SET_VIOLENCE_TERORISM_VALID,
    error,
});

export const setShareEmailValue = (value) => ({
    type: SET_SHARE_EMAIL_VALUE,
    value,
});

export const setShareEmailValid = (error) => ({
    type: SET_SHARE_EMAIL_VALID,
    error,
});

export const setExpiredAuth = (value) => ({
    type: TOKEN_IS_EXPIRED,
    value,
});

export const setSideBarOpen = (value) => ({ type: AFYA_IMARA_SIDEBAR_OPEN_VALUE, value });
export const setShowShareModal = (value) => ({ type: AFYA_IMARA_SHARE_QUOTE_VALUE, value });

//new values
export const setDOBValue = (value) => ({
    type: DOB_SET_VALUE,
    value,
});
export const setDOBValid = (error) => ({
    type: DOB_SET_VALID,
    error,
});

export const setCoverLimitValue = (value) => ({
    type: COVER_LIMIT_SET_VALUE,
    value,
});
export const setCoverLimitValid = (error) => ({
    type: COVER_LIMIT_SET_VALID,
    error,
});

export const setProfessionValue = (value) => ({
    type: PROFESSION_SET_VALUE,
    value,
});
export const setProfessionValid = (error) => ({
    type: PROFESSION_SET_VALID,
    error,
});

export const setSpouseIncludedValue = (value) => ({
    type: SPOUSE_INCLUDED_SET_VALUE,
    value,
});
export const setSpouseIncludedValid = (error) => ({
    type: SPOUSE_INCLUDED_SET_VALID,
    error,
});

export const setSpouseDobValue = (value) => ({
    type: SPOUSE_DOB_SET_VALUE,
    value,
});
export const setSpouseDobValid = (error) => ({
    type: SPOUSE_DOB_SET_VALID,
    error,
});

export const setChildrenIncludedValue = (value) => ({
    type: CHILDREN_INCLUDED_SET_VALUE,
    value,
});
export const setChildrenIncludedValid = (error) => ({
    type: CHILDREN_INCLUDED_SET_VALID,
    error,
});

export const setChildrenDobsValue = (value) => ({
    type: CHILDREN_DOBS_SET_VALUE,
    value,
});
export const setChildrenDobsValid = (error) => ({
    type: CHILDREN_DOBS_SET_VALID,
    error,
});

export const setChildrenDobsArrayValue = (value) => ({
    type: CHILDREN_DOBS_ARRAY_SET_VALUE,
    value,
});
export const setChildrenDobsArrayValid = (error) => ({
    type: CHILDREN_DOBS_ARRAY_SET_VALID,
    error,
});

export const setSelectedCoverOptionValue = (value) => ({
    type: SELECTED_COVER_OPTION_SET_VALUE,
    value,
});

export const triggerGetAllProducts = () => ({
    type: TRIGGER_GET_ALL_PRODUCTS,
});

export const setCoverOptionsValue = (value) => ({
    type: SET_COVER_OPTIONS_LIST_VALUE,
    value,
});
export const setCoverOptionsValid = (error) => ({
    type: SET_COVER_OPTIONS_LIST_VALID,
    error,
});

export const setInpatientCoverValue = (value) => ({
    type: SET_INPATIENT_COVER_VALUE,
    value,
});

export const setInpatientCoverValid = (error) => ({
    type: SET_INPATIENT_COVER_VALID,
    error,
});

export const setOutpatientCoverValue = (value) => ({
    type: SET_OUTPATIENT_COVER_VALUE,
    value,
});

export const setOutpatientCoverValid = (error) => ({
    type: SET_OUTPATIENT_COVER_VALID,
    error,
});

export const setOutpatientLimitValue = (value) => ({
    type: SET_OUTPATIENT_LIMIT_VALUE,
    value,
});

export const setOutpatientCoverOptionValue = (value) => ({
    type: SET_OUTPATIENT_COVER_OPTION_VALUE,
    value,
});

export const setOutpatientCoverOptionValid = (error) => ({
    type: SET_OUTPATIENT_COVER_OPTION_VALID,
    error,
});

export const setProductsValue = (value) => ({
    type: SET_AFYA_IMARA_PRODUCTS_VALUE,
    value,
});

export const setProductsValid = (error) => ({
    type: SET_AFYA_IMARA_PRODUCTS_VALID,
    error,
});

export const setFullNameValue = (value) => ({
    type: SET_FULL_NAME_VALUE,
    value,
});

export const setFullNameValid = (error) => ({
    type: SET_FULL_NAME_VALID,
    error,
});

export const setEmailValue = (value) => ({
    type: SET_EMAIL_VALUE,
    value,
});
export const setEmailValid = (error) => ({
    type: SET_EMAIL_VALID,
    error,
});

export const setPhoneNoValue = (value) => ({
    type: SET_PHONE_NO_VALUE,
    value,
});
export const setPhoneNoValid = (error) => ({
    type: SET_PHONE_NO_VALID,
    error,
});
